import { useEffect, useState } from "react";
import MarkdownIt from "markdown-it";

import { Layout } from "../../../components";
import { getPages } from "../api";


const PrivacyPolicy = () => {

  const [privacyPolicy, setPrivacyPolicy] = useState<string>('');


  const mdParser = new MarkdownIt({
    html: true,
    linkify: true,
    typographer: true,
  });

  useEffect(() => {
    getPages({type:1}).then(res => {
      setPrivacyPolicy(res.data.data.content);
    });
    window.scrollTo(0, 0);
  }, [])

  return (
    <Layout>
      <div className="container">
        <h3 className="text-center mt-5 mb-3">Privacy Policy </h3>
        <div
          // className="mb-5"
          // dangerouslySetInnerHTML={{
          //   __html: mdParser.render(privacyPolicy),
          // }}
        />
  <h1>Privacy Policy</h1>

<p>
  Welcome to TravelX. Your privacy is important to us. This privacy policy explains how we collect, use, and protect your personal information when you visit our website.
</p>

<p>
  This privacy policy aims to provide you with information on how TravelX collects and processes your data through this website, including any data you may provide when you sign up for our services, purchase a product or service, or participate in a promotion.
</p>

<p>
  We do not sell or rent your personal information. We may share your data with service providers who assist us in operating our website and conducting our business, or with legal authorities if required by law.
</p>

<p>
  We implement appropriate security measures to protect your data from unauthorized access and disclosure.
</p>

<p>
  We may update this policy occasionally. We’ll let you know of any significant changes by posting the new policy on our website.
</p>

<p>
  If you have any questions or concerns about this privacy policy, please contact us at <a href="mailto:support@travelx.ai">support@travelx.ai</a>.
</p>
      </div>
    </Layout>
  );
};

export default PrivacyPolicy;